import React, { useState } from 'react';
import { useAuthStore } from '../stores/authStore';
import { useNavigationStore } from '../stores/navigationStore';
import LeftNavigation from './LeftNavigation';
import TopNavigation from './TopNavigation';
import ReservationCalendar from '../screens/ReservationCalendar';
import BanquetManagement from '../screens/BanquetManagement';
import CorporateOutings from '../screens/CorporateOutings';
import RoomManagement from '../screens/RoomManagement';
import Inventory from '../screens/Inventory';
import RestaurantManagement from '../screens/RestaurantManagement';
import BarManagement from '../screens/BarManagement';
import UserManagement from '../screens/UserManagement';
import FinanceAndAccounting from '../screens/FinanceAndAccounting';
import Insights from '../screens/Insights';
import ReportingCenter from '../screens/ReportingCenter';
import CRM from '../screens/CRM';
import Loyalty from '../screens/Loyalty';
import AIChatbot from './AIChatbot';

const MainLayout: React.FC = () => {
  const { isAuthenticated } = useAuthStore();
  const { currentScreen, isSidebarCollapsed } = useNavigationStore();
  const [isChatbotOpen, setIsChatbotOpen] = useState(false);

  if (!isAuthenticated) {
    return null; // This will be handled by App.tsx
  }

  return (
    <div className="min-h-screen flex">
      {/* Left Navigation */}
      <LeftNavigation />
      
      {/* Main Content Area */}
      <div 
        className={`flex-1 flex flex-col min-h-screen transition-all duration-300 ease-in-out ${
          isChatbotOpen ? 'mr-96' : 'mr-0'
        }`}
      >
        {/* Top Navigation */}
        <TopNavigation onChatbotToggle={setIsChatbotOpen} />
        
        {/* Main Content */}
        <div className="flex-1 p-6 overflow-auto">
          {/* Front Office */}
          {currentScreen === 'reservation-calendar' && <ReservationCalendar />}
          {currentScreen === 'banquet-management' && <BanquetManagement />}
          {currentScreen === 'corporate-outings' && <CorporateOutings />}
          
          {/* Back Office */}
          {currentScreen === 'room-management' && <RoomManagement />}
          {currentScreen === 'inventory' && <Inventory />}
          
          {/* Point of Sale */}
          {currentScreen === 'restaurant-management' && <RestaurantManagement />}
          {currentScreen === 'bar-management' && <BarManagement />}
          
          {/* Accounts */}
          {currentScreen === 'finance-accounting' && <FinanceAndAccounting />}
          
          {/* Insights */}
          {currentScreen === 'insights' && <Insights />}
          {currentScreen === 'reporting-center' && <ReportingCenter />}
          
          {/* Guests & CRM */}
          {currentScreen === 'crm' && <CRM />}
          {currentScreen === 'loyalty' && <Loyalty />}
          
          {/* Admin */}
          {currentScreen === 'user-management' && <UserManagement />}
        </div>
      </div>

      {/* AI Chatbot Sidebar */}
      <AIChatbot isOpen={isChatbotOpen} onClose={() => setIsChatbotOpen(false)} />
    </div>
  );
};

export default MainLayout;

